import { Form } from 'antd';
import type { FC } from 'react';

import type { ExtranetHotelContacts } from 'app/typings/core/extranet/hotel/contacts';

import { HeaderWrapper } from '../HeaderWrapper/HeaderWrapper';

import { BuilderContact } from './Contacts/Contacts';

export const ProfileForm: FC<Props> = ({
  hotelId,
  onFinish,
  isLoading = false,
}) => {
  const [form] = Form.useForm<ExtranetHotelContacts>();

  return (
    <HeaderWrapper
      nextDisabled={false}
      handleNext={() => form.submit()}
      isLoading={isLoading}
    >
      <BuilderContact hotelId={hotelId} form={form} onFinish={onFinish} />
    </HeaderWrapper>
  );
};

type Props = {
  hotelId: number;
  onFinish: (values: ExtranetHotelContacts) => void;
  isLoading?: boolean;
};
